import jwt_decode from "jwt-decode";

const token = `${process.env.REACT_APP_TOKEN}`;

export const authGuest = async conn => {
  const response = await conn.get("login");
  return response;
};

export const login = async (conn, id, loginPwd) => {
  const response = await conn.post("login", {
    userId: id,
    password: loginPwd,
  });
  return response;
};

// 새로운 계정의 패스워드 등록 시 사용 서비스
export const setNewPassword = async (conn, id, loginPwd) => {
  const response = await conn.post("/user/new/password", {
    userId: id,
    password: loginPwd,
  });
  return response;
};

export const getUser = () => {
  const cwtk = localStorage.getItem("cwtk");
  if (cwtk) {
    const decode = jwt_decode(cwtk);
    // console.log("decode = ", decode);
    return {
      userId: decode.sub,
      userTerm: decode.userTerm,
      userTypeCode: decode.userTypeCode,
      userCelphone: decode.userPhone,
      rgnCode: decode.rgnCode,
      dongCode: decode.dongCode,
      exp: decode.exp,
      iat: decode.iat,
      push: decode.push
    };
  } else
    return {
      userId: "",
      userTerm: "",
      userTypeCode: "",
      userCelphone: "",
      rgnCode: "",
      dongCode: "",
      exp: "",
      iat: "",
      push: "",
    };
};

export const getToken = () => localStorage.getItem(token) || null;
export const setToken = token => localStorage.setItem(`${process.env.REACT_APP_TOKEN}`, token);
export const setDelToken = () => localStorage.removeItem(token);

export const getUserTypeCode = () => {
  const decode = jwt_decode(localStorage.getItem(token));
  return decode.userTypeCode;
};

export const isAuthenticated = () => {
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (
    user &&
    (user.userTypeCode == 2001 || user.userTypeCode == 2002 || user.userTypeCode == 2003 || user.userTypeCode == 2004 || user.userTypeCode == 2005 || user.userTypeCode == 2006)
  )
    return true;
  else return false;
};

export const isLogin = () => {
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user && (user.userTypeCode == 2001 || user.userTypeCode == 2002 || user.userTypeCode == 2003 || user.userTypeCode == 2005 || user.userTypeCode == 2006)) return true;
  else return false;
};

export const isDeveloper = () => {
  // const token = localStorage.getItem(token);
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2005) return true;
  else return false;
};

export const isAdmin = () => {
  // const token = localStorage.getItem(token);
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2003 || user.userTypeCode == 2005) return true;
  else return false;
};

export const isRgnAdmin = () => {
  // const token = localStorage.getItem(token);
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2003) return true;
  else return false;
};

export const isManager = () => {
  // const token = localStorage.getItem(token);
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2002) return true;
  else return false;
};

export const isUser = () => {
  // const token = localStorage.getItem(localStorage.getItem(token));
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2001) return true;
  else return false;
};

export const isProtector = () => {
  // const token = localStorage.getItem(localStorage.getItem(token));
  if (!localStorage.getItem(token)) return false;
  const user = jwt_decode(localStorage.getItem(token));
  if (user.userTypeCode == 2006) return true;
  else return false;
};

// 페이지 진입 시 히스토리(사용자접속이력)에 저장하기 위한 서비스
export const setUserHistPage = async (conn, user, url) => {
  const response = await conn.post("/accslog/set/pageInfo", {
    userId: user ? user.userId : null,
    url: url,
  });
  return response;
};


export const checkAdmToken = async (conn) => {
  const token = localStorage.getItem("cwtk");
  const decode = jwt_decode(token);

  const response = await conn.get("/login/adm/checkToken", {
    params: {
      userId: decode.sub,
      token: token,
    },
  });
  return response;
};
export const delAdmToken = async (conn, id) => {
  const response = await conn.post("/login/adm/delToken/" + id);
  return response;
};

export const setLoginFail = async (conn, id) => {
  const response = await conn.post("/login/fail/" + id);
  return response;
};